<template>
  <div class="employee-line-menu">
    <MenuIcon
      :dropdownItems="visibleMenuItems"
      @onClick="handleMenuClick"
      :menuWidth="true"
      :isOpen="menuOpen"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MenuIcon from '@components/MenuIcon/MenuIcon.vue';

const props = defineProps({
  employee: { type: Object, required: true },
  status: { type: String, default: 'Draft' },
  menuOpen: { type: Boolean, default: false }
});

const emit = defineEmits(['action']);

const visibleMenuItems = computed(() => {
  const status = props.status?.toLowerCase();
  const isArchived = props.employee.archived;
  return [
    { name: 'Copy link', value: 'copyLink', icon: 'icons/dropdown/copy-link.svg' },
    status === 'draft' && { name: 'Activate', value: 'activate', icon: 'icons/dropdown/activate.svg' },
    status === 'draft' && { name: 'Delete', value: 'delete', icon: 'icons/dropdown/trash.svg', destructive: true, negative: true },
    status === 'active' && { name: 'Terminate', value: 'terminate', icon: 'icons/dropdown/activate.svg' },
    status === 'terminated' && !isArchived && { name: 'Reactivate', value: 'reactivate', icon: 'icons/dropdown/activate.svg' },
    { name: 'Rename', value: 'rename', icon: 'icons/dropdown/rename1.svg' },
    status === 'active' && !props.employee.isSuspended && !props.employee.hasAccess && { name: 'Give Access', value: 'giveAccess', icon: 'icons/dropdown/access.svg', isWorkflow: true },
    status === 'active' && props.employee.isSuspended && !props.employee.hasAccess && { name: 'Restore Access', value: 'restoreAccess', icon: 'icons/dropdown/access.svg' },
    status === 'active' && !props.employee.isSuspended && props.employee.hasAccess && { name: 'Suspend Access', value: 'suspendAccess', icon: 'icons/dropdown/suspendaccess.svg', destructive: true, negative: true },
    { name: 'Change Picture', value: 'changePicture', icon: 'icons/dropdown/change_picture.svg' },
    status === 'terminated' && !isArchived && { name: 'Archive', value: 'archive', icon: 'icons/dropdown/archive-new.svg', negative: false },
    status === 'archived' && isArchived && { name: 'Unarchive', value: 'unarchive', icon: 'icons/dropdown/unarchive.svg' }
  ].filter(Boolean);
});

function handleMenuClick(item) {
  if (item && item.value) {
    emit('action', { type: item.value, employee: props.employee });
  }
}
</script>
<style scoped>
.employee-line-menu {
  width: 20%;
  text-align: end;
}
</style>